import { __extends } from "tslib";
import React from 'react';
import { utils } from '../utils/utils';
import { window, customDownloadUrlThrottleDownload, } from '@wix/photography-client-lib';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import Download from 'wix-ui-icons-common/on-stage/Download';
var FullscreenSocialDownload = /** @class */ (function (_super) {
    __extends(FullscreenSocialDownload, _super);
    function FullscreenSocialDownload(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        return _this;
    }
    FullscreenSocialDownload.prototype.onKeyPress = function (e, downloadLink, curItem) {
        switch (e.keyCode || e.charCode) {
            case 32: // space
            case 13: // enter
                e.preventDefault();
                if (utils.isiOS()) {
                    window.open(downloadLink);
                }
                else {
                    window.open(downloadLink, '_blank');
                }
                this.props.actions.eventsListener(FULLSCREEN_EVENTS.DOWNLOAD_BUTTON_CLICKED, curItem);
                return false;
        }
    };
    FullscreenSocialDownload.prototype.onKeyPressText = function (e, curItem) {
        switch (e.keyCode || e.charCode) {
            case 32: // space
            case 13: // enter
                e.preventDefault();
                this.props.actions.eventsListener(FULLSCREEN_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, curItem);
                return false;
        }
    };
    FullscreenSocialDownload.prototype.openDownloadUrl = function (url) {
        if (utils.isiOS()) {
            window.open(url);
        }
        else {
            window.open(url, '_blank');
        }
    };
    FullscreenSocialDownload.prototype.render = function () {
        var _this = this;
        var _a = this.props, device = _a.device, current = _a.current, styles = _a.styles;
        var curItem = current.item;
        var downloadUrl = styles.isStoreGallery ? 'download_sample' : 'download';
        var downloadLink = curItem.createUrl(downloadUrl, 'video') ||
            curItem.createUrl(downloadUrl, 'img');
        var downloadClassNames = [
            "fullscreen-social-download ",
            device === 'desktop' ? 'fullscreen-icon' : '',
            'has-custom-focus',
        ].join(' ') +
            (utils.isMobile ? ' pro-fullscreen-mobile-social-icon' : '');
        return styles.allowDownload && !curItem.isDemo ? (curItem.isText ? (React.createElement("a", { className: downloadClassNames, style: this.props.style, tabIndex: 0, "aria-label": "Download ".concat(curItem.type, " to your device"), role: "button", title: "Download", onClick: function (evt) {
                evt.stopPropagation();
                _this.props.actions.eventsListener(FULLSCREEN_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, curItem);
            }, onKeyDown: function (e) { return _this.onKeyPressText(e, curItem); } },
            React.createElement(Download, null))) : (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        React.createElement("a", { className: downloadClassNames, style: this.props.style, tabIndex: 0, "aria-label": "Download ".concat(curItem.type, " to your device"), role: "button", title: "Download", target: "_blank", onClick: function (e) {
                e.preventDefault();
                var customDownloadUrl = _this.props.customDownloadUrl;
                var url = downloadLink;
                if (customDownloadUrl) {
                    var _a = curItem.dto, mediaUrl = _a.mediaUrl, itemId = _a.itemId;
                    customDownloadUrlThrottleDownload(customDownloadUrl, mediaUrl, itemId);
                }
                else {
                    _this.openDownloadUrl(url);
                }
                _this.props.actions.eventsListener(FULLSCREEN_EVENTS.DOWNLOAD_BUTTON_CLICKED, curItem);
            }, onKeyDown: function (e) { return _this.onKeyPress(e, downloadLink, curItem); } },
            React.createElement(Download, null)))) : (false);
    };
    return FullscreenSocialDownload;
}(React.Component));
export default FullscreenSocialDownload;
//# sourceMappingURL=fullscreenSocialDownload.js.map